var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

var timeout;

(function($, global, google) {
    "use strict";
    var chroma = global.chroma;
    var debugMode = false;
    if(typeof(sessionStorage) !== 'undefined') {
        debugMode = sessionStorage.getItem('debug') === 'true'; 
    }

	
    var mapShapeZoomLevelKendo = 3,
        mapShapeZoomLevelGoogle = 6;
    
    var googleMapWidgetType = 47;
	
	
    MDB.Charts.renderers.map_generic = function(widget, chart, data, metadata, renderImpl){
        if (!data || data.length === 0) {
            widget.find('.loading-box').hide();
            return;
        }

        var widgetType = widget.data('type');
        
        var chroma = window.chroma;
        var zipcodeAreaFiles = ['NL']; //Default to NL
        // var shapeZoomLevel = mapShapeZoomLevelGoogle;
        

        if (metadata && metadata.KendoConfig && metadata.KendoConfig.zipcodeAreaFiles) {
            var metaZipcodeAreaFiles = metadata.KendoConfig.zipcodeAreaFiles;
            if (metaZipcodeAreaFiles.length) {
                if (!_.isArray(metaZipcodeAreaFiles)) {
                    metaZipcodeAreaFiles = [metaZipcodeAreaFiles];
                }

                zipcodeAreaFiles = _.uniq(metaZipcodeAreaFiles);
            }
        }


        setTimeout(function () {
            var container = $('<div class="map">').css({ width: '90%', height: '90%', top: '5%', left: '5%', position: 'relative' });
            var containerId = 'MAP_' + MDB.guid();
            var geoJsonPerZipArea = {};
            
            //Currently only used by google widget
            if (widgetType == googleMapWidgetType){
                zipcodeAreaFiles.forEach(function (zipcode) {
                    geoJsonPerZipArea[zipcode] = $.getJSON(getCombinedGeoJsonUrl(mapShapeZoomLevelGoogle, zipcode));
                });  
            } 

            container.attr('id', containerId);


            var kendoConfig = metadata.KendoConfig;

            var colors = [];
            if (kendoConfig.seriesColors !== undefined) {
                colors = kendoConfig.seriesColors;
            } else {
                colors = ["#8BBD4C", "#9FBE49", "#B4BF47", "#C0B645", "#C1A143", "#C38B40", "#C4733E", "#C55B3B", "#C64139", "#C83748"];
            }

            var keys = Object.keys(data[0]);
            var aliasses = widget.data('titles') || '{}';
            aliasses = JSON.parse(aliasses);

            var zipcodeColumn = 'PostcodeNum',
                amountColumn = 'PostcodeNum1',
                latitudeColumn = 'Latitude',
                longitudeColumn = 'Longitude',
                markerColumn = 'Marker';

            zipcodeColumn = keys[0]; // group by

            if (aliasses && keys) {
                // find column named Aantal
                // find column named Postcode
                Object.keys(aliasses).forEach(function (key, index) {
                    if (aliasses[key] === 'Aantal') {
                        amountColumn = key;
                    } else if (aliasses[key] === 'Postcode') {
                        zipcodeColumn = key;
                    } else if (aliasses[key] === 'Marker') {
                        markerColumn = key;
                    }
                });
            }

            var rows = [];
            var latAvg = 0;
            var lngAvg = 0;
            var minValue = Number.MAX_VALUE,
                maxValue = 0;

            var zipcodes = [],
                zipcodeMap = {};

            data.forEach(function(value, index) {
                var amount = value[amountColumn];
                var zipcode = value[zipcodeColumn];
                var marker = value[markerColumn],
                    markerLat=value[latitudeColumn],
                    markerLng=value[longitudeColumn];

                if(marker > 0 && markerLat && markerLng) {
                    rows.push({
                        lat: markerLat,
                        lon: markerLng,
                        tooltip: marker

                        // position: {
                        //     lat: markerLat,
                        //     lng: markerLng
                        // },
                        // title: marker
                    });
                }

                if (!value || !amount) {
                    return;
                }

                zipcodes.push(zipcode);
                zipcodeMap[zipcode] = amount;

                minValue = Math.min(minValue, amount);
                maxValue = Math.max(maxValue, amount);
            });

            zipcodes.sort();

            if (rows.length > 0) {
                latAvg = latAvg / rows.length;
                lngAvg = lngAvg / rows.length;
            }

            // http://stackoverflow.com/a/12910008
            var chromaScale = chroma
                .scale(colors)
                //.scale(["white", "green"])
                .domain([1, 500]);
            var one = maxValue / 500;
            var getHeatmapColor = function (value) {
                value = (value / one);
                return chromaScale(value).hex();
            };

            MDB.Charts.emptyChartAndMakeVisible(widget, chart);

            chart.append(container);

            var popover = appendPopover(widget);

            renderImpl(containerId, {
                getValueForZipcode: function(zipcode){
                    return zipcodeMap[zipcode] || 0
                },
                getZipcodeHeatmapColor: function(zipcode){
                    var value = this.getValueForZipcode(zipcode);
                    return value > 0 ? getHeatmapColor(value) : '#FFFFFF';
                },
                getZipcodeHeatmapOpacity: function(zipcode){
                    var value = this.getValueForZipcode(zipcode);
                    return value > 0 ? 0.8 : 0.1;
                },
                loadGeoJson: function(){
                    return _.map(zipcodeAreaFiles, function(areaFile){
                        return geoJsonPerZipArea[areaFile]
                    });
                },
                getCombinedGeoJsonUrl: function(zoom){
                    return getCombinedGeoJsonUrl(zoom, zipcodeAreaFiles);
                    //return sprintf('/api/Map/GeoJson/All?zoom=%s&areaCodes=%s', zoom, zipcodeAreaFiles.join('1'));
                },
                getFilteredGeoJsonUrls: function(zoom){
                    var batchSize = 75;
                    
                    return _.filter(_.map(_.range(0, zipcodes.length + batchSize, batchSize), function (batch) {
                        var batchZipcodes = zipcodes.slice(batch, Math.min(zipcodes.length, batch)).join(',');
                        if (!batchZipcodes || !batchZipcodes.length){
                            return undefined;
                        }
                        
                        return sprintf('/api/Map/GeoJson/Combined?zoom=%s&filter=%', zoom,  batchZipcodes)
                    }));
                },
                displayPopover: function (zipcode) {
                    displayPopover(popover, zipcode);
                },
                hidePopover: function () {
                    popover.hide();
                    var timeout = popover.data('timeout');
                    
                    if (timeout){
                        clearTimeout(timeout);
                    } 
                },

                markers: rows,
                strokeColor: '#696868',
                baseZoom: 8,
                hoverOpacity: 0.2,
                centerLat: latAvg !== 0 ? latAvg : 53.2167,
                centerLon: lngAvg !== 0 ? lngAvg : 6.5667
            });
        }, 0);
        
        function getCombinedGeoJsonUrl(zoom, zipcodeAreaFiles){
            zipcodeAreaFiles = _.isArray(zipcodeAreaFiles) ? zipcodeAreaFiles : [zipcodeAreaFiles];
            return sprintf('/api/Map/GeoJson/All?zoom=%s&areaCodes=%s', zoom, zipcodeAreaFiles.join('1'));
        }

        function displayPopover(popover, zipcode) {
            var prev = popover.data('active_req');
            if (prev && prev.abort && popover.data('current_zip') !== zipcode) {
                prev.abort();
            }
            popover.data('current_zip', zipcode);

            var tooltip = getTooltip(zipcode);
            popover.data('active_req', tooltip);

            tooltip.done(function (tooltip) {
                popover.data('active_req', null);
                // check if there is a title & body (no triple = here)
                if(tooltip.title && tooltip.body) {
                    // only show if we haven't requested another tooltip by now
                    if (popover.data('current_zip') === zipcode) {
                        setPopoverText(popover, tooltip.title, tooltip.body);
                        popover.show();

                        //Autohide if popover has been opened for over 30 seconds.
                        var timeout = setTimeout(function () {
                            popover.hide();
                        }, 30000);
                        
                        popover.data('timeout', timeout);
                    }
                }
            });
        }

        function getTooltip(zipcode) {
            var cachedTooltipPrefix = 'KendoMapTooltip:';

            var start = MDB.Charts.dateStart,
                end = MDB.Charts.dateEnd,
                selectedDivision = MDB.isGuid(MDB.Charts.divisionId) ? MDB.Charts.divisionId : MDB.CurrentUser.DivisionId;

            var cacheTooltipKey = [cachedTooltipPrefix, zipcode, start, end, selectedDivision].join('|');

            var d = new $.Deferred();
            var promise = d.promise();

            var cachedTooltip = getCachedTooltip(cacheTooltipKey);

            if (cachedTooltip) {
                d.resolve(cachedTooltip);
                return promise;
            }

            var xhr= $.ajax({
                type: "GET",
                url: '/api/Map/GeoJson/Tooltip',
                contentType: "application/json; charset=utf-8",
                data: {
                    zipcode: zipcode,
                    start: start,
                    end: end,
                    divisionId:selectedDivision
                },
                dataType: "json",
                success: function(data) {
                    var tooltip = {
                        title: data.title,
                        body: data.body,
                        zipcode: data.zipcode
                    };

                    cacheToolTip(cacheTooltipKey, tooltip);
                    d.resolve(tooltip);
                },
                error: function(data) {
                    d.reject(data);

                    //https://stackoverflow.com/a/12833796/3697715
                    //Ignore abort 'errors', since we cause them ourselves
                    if (data && data.statusText !== 'abort'){
                        console.error(data);
                    }
                }
            });

            // expose abort
            promise.abort = function() {
                xhr.abort();
            };

            return promise;
        }

        function appendPopover() {
            var popover = $('<div class="popover map-popover">');

            chart.append(popover);
            popover.hide();

            $('<div class="panel panel-info map-popover">')
                .append('<div class="panel-heading map-popover">')
                .append('<div class="panel-body map-popover">')
                .appendTo(popover);

            chart.on('mousemove', function (e) {
                //Removed this condition because it causes the popover to snap across the screen. No noticable speed difference
                //if(popover.is(':visible')) { 
                var offset = $(this).offset();
                var left = e.pageX - offset.left + 10;
                var top = e.pageY - offset.top;
                var theHeight = popover.height();

                popover.css('left', (left + 10) + 'px');
                popover.css('top', (top - (theHeight / 2) + 100) + 'px');
                //}
            });

            return popover;
        }

        function setPopoverText(popover, textTitle, textBody) {
            popover.find('.map-popover.panel-heading').html('<p><b>' + textTitle + '</b></p>');
            popover.find('.map-popover.panel-body').html('<p>' + textBody + '<p>');
        }

        function cacheToolTip(key, tooltip) {
            if(typeof(sessionStorage) !== 'undefined') {
                sessionStorage.setItem(key, JSON.stringify(tooltip));
            }
        }

        function getCachedTooltip(key) {
            var stored = typeof (sessionStorage) === 'undefined' ? null : sessionStorage.getItem(key);
            if (stored) {
                return JSON.parse(stored);
            }
        }
    };
    // map chart
    MDB.Charts.renderers.map_pc = function (widget, chart, data, metadata) {
        var loadAll = true
            // , showExportButtons = false
            , zoomLevel = mapShapeZoomLevelKendo
            , widgetId = widget.data('id');

        //draw map
        chart.css({ 'min-height': '300px', overflow: 'hidden' });
        
        MDB.Charts.renderers.map_generic(widget, chart, data, metadata, function (containerId, renderConfig) {
            var container = $(document.getElementById(containerId));
            
            var layers = [
                {
                    type: "tile",
                    urlTemplate: "//#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                    subdomains: ["a", "b", "c"],
                    attribution: "&copy; <a href='http://osm.org/copyright'>OpenStreetMap contributors</a>"
                }
            ];
            
            if (loadAll) {
                layers.push({
                    type: "shape",
                    dataSource: {
                        type: "geojson",
                        transport: {
                            read: renderConfig.getCombinedGeoJsonUrl(zoomLevel)
                        }
                    },
                    style: {
                        fill: {
                            opacity: 1
                        },
                        stroke: {
                            color: renderConfig.strokeColor
                        }
                    }
                });
            } else {
                renderConfig.getFilteredGeoJsonUrls(zoomLevel).forEach(function (batchUrl) {
                    layers.push({
                        type: "shape",
                        dataSource: {
                            type: "geojson",
                            transport: {
                                read: batchUrl
                            }
                        },
                        style: {
                            fill: {
                                color: 'white',
                                opacity: 1
                            }
                        }
                    }); 
                });
            }
            
            //Adding layers after initialisation is not possible
            //Reading markers from a datasource ignores at leas the tooltip/shape options
            //Manually read + create markers after the chart has been initialized
            if(metadata && metadata.KendoConfig && metadata.KendoConfig.customMarkers){
                layers.push({
                    _id: 'MARKER_LAYER',
                    type: 'marker'
                });
            }

            var cfg = {
                center: [renderConfig.centerLat, renderConfig.centerLon],//latAvg != 0 ? [latAvg, lngAvg] : [53.2167, 6.5667],
                zoom: renderConfig.baseZoom,
                controls: {
                    attribution: false,
                    navigator: false
                },
                markerDefaults: {
                    shape: "pinTarget"
                },
                layers: layers,
                zoomEnd: onZoomEnd,
                shapeCreated: onShapeCreated,
                // shapeClick: shapeClick,
                shapeMouseEnter: onShapeMouseEnter,
                shapeMouseLeave: onShapeMouseLeave,
                markers: _.map(renderConfig.markers, function (marker) {
                    return {
                        location: [marker.lat, marker.lon],
                        tooltip: {
                            content: ''+marker.tooltip
                        },
                        // shape: marker.shape
                    }
                })
            };

            function shapeClick(e) {
                var shape = e.shape;
                console.log(shape.options);
                var zip = shape.dataItem && shape.dataItem.properties && shape.dataItem.properties.zipcode;
                if(debugMode) {
                    console.log("Clicked on zipcode " + zip);
                }
            }

            function onShapeCreated(e) {
                var shape = e.shape;
                if(!shape.dataItem || !shape.dataItem.properties){
                    return;
                }
                
                var zip = shape.dataItem.properties.zipcode;
                
                var val = renderConfig.getValueForZipcode(zip);
                var color = renderConfig.getZipcodeHeatmapColor(zip);
                var opacity = renderConfig.getZipcodeHeatmapOpacity(zip);

                if (val > 0) {
                    e.shape._nxvalue = val;
                    shape._nxcolor = color;
                }
                
                shape.options.fill.set("color", color);
                shape.options.set("fill.opacity", opacity);
            }

            function onShapeMouseEnter(e) {
                var shape = e.shape;
                var zipcode = undefined; 
                
                if (shape.dataItem && shape.dataItem.properties && shape.dataItem.properties.zipcode){
                    zipcode = shape.dataItem.properties.zipcode;
                } 
                
                var value = zipcode ? renderConfig.getValueForZipcode(zipcode) : undefined;
                
                shape.options.set("fill.opacity", renderConfig.hoverOpacity);
                
                if (!value){
                    renderConfig.hidePopover();
                    
                    if (shape._nxlabel) {
                        shape._nxlabel.options.set('visible', true);
                    }
                    
                    return;
                }
                
                
                renderConfig.displayPopover(zipcode);
                
                if (shape._nxlabel) {
                    shape._nxlabel.options.set('visible', true);
                }
            }
            
            function onShapeMouseLeave(e) {
                var shape = e.shape;
                var zipcode = undefined;

                if (shape.dataItem && shape.dataItem.properties && shape.dataItem.properties.zipcode){
                    zipcode = shape.dataItem.properties.zipcode;
                }
                
                e.shape.options.set('fill.opacity', renderConfig.getZipcodeHeatmapOpacity(zipcode));

                renderConfig.hidePopover();
                
                if (e.shape._nxlabel){
                    e.shape._nxlabel.options.set('visible', false);
                }
            }

            function onZoomEnd(){
                var kendoWidget = this
                    , currentZoom = kendoWidget.options.zoom
                    , markerLayer = getMarkerLayer();
                
                container.attr('data-zoom', currentZoom);

                if(!markerLayer){
                    return;
                }

                var minZoom = 10;

                if(currentZoom >= minZoom){
                    markerLayer.show();
                } else{
                    markerLayer.hide();
                }
            }
            
            container.kendoMap(cfg);
            
            var extent = new kendo.dataviz.map.Extent([51.6603208, 7.5102545], [51.3467182, 3.2493574]);
            extent.include([53.353864, 4.8398091]);

            var map = container.data('kendoMap');
            map.extent(extent);
            
            var markerLayer = getMarkerLayer();
            if(markerLayer){
                markerLayer.hide();
                
                //DNX-559, DivisionId will always be a GUID
                var queryString = $.param({
                    widgetId: widgetId,
                    divisionId: MDB.isGuid(MDB.Charts.divisionId) ? MDB.Charts.divisionId : MDB.CurrentUser.DivisionId,
                    start: MDB.Charts.dateStart,
                    end: MDB.Charts.dateEnd
                });

                //WebApi requires a raw unnamed array in the request body
                //Hence we need to handle the serialization ourselves
                $.ajax({
                    url: '/api/Map/GeoJson/Markers?' + queryString,
                    type: 'POST',
                    data: JSON.stringify(MDB.Charts.getWidgetArraySerializedFilters(widget)),
                    processData: false,
                    contentType: 'application/json'
                })
                    .done(function(data){
                        var kendoShapes = ['pin', 'pinTarget'];
                    
                        data.forEach(function(d){
                        //Kendo appends the shape value to the k-marker- class
                        //When we have a custom shape, mark it as such by prefixing it with 'custom-marker'
                        //This results in kendo assiging two classes as follows: 'k-marker-custom-marker {our shape class}'
                        
                            if(d.shape && kendoShapes.indexOf(d.shape) === -1){
                                d.shape = 'custom-marker ' + d.shape;
                            }
                        
                            markerLayer.add(d)
                        });
                    });
            }

            function getMarkerLayer(){
                return _.find(map.layers, ['options._id', 'MARKER_LAYER']);
            }
        });

        // if (showExportButtons) {
        //     widget.find('.box-header .box-tools')
        //         .prepend('<button class="export-img btn btn-primary btn-sm"><i class="fa fa-file-image-o"></i></button>');
        //     widget.find('.box-header .box-tools')
        //         .prepend('<button class="export-pdf btn btn-primary btn-sm"><i class="fa fa-file-pdf-o"></i></button>');
        //
        //     widget.find(".export-img,.export-pdf").bind('click', function() {
        //         // Convert the DOM element to a drawing using kendo.drawing.drawDOM
        //         var isPdf = $(this).hasClass('export-pdf');
        //         var fileExt = isPdf ? '.pdf' : '.png';
        //         var fileName = widget.find('.box-title').text() || 'Map';
        //         kendo.drawing.drawDOM(widget.find('.chart'))
        //             .then(function(group) {
        //                 // Render the result as a PNG image
        //                 if (isPdf) {
        //                     return kendo.drawing.exportPDF(group, {
        //                         paperSize: "auto",
        //                         margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }
        //                     });
        //                 }
        //                 return kendo.drawing.exportImage(group);
        //             })
        //             .done(function(imageData) {
        //                 // Save the image file
        //                 kendo.saveAs({
        //                     dataURI: imageData,
        //                     //proxyURL: "http://demos.telerik.com/kendo-ui/service/export",
        //                     fileName: fileName + fileExt
        //                 });
        //             });
        //     });
        // }
    };

    MDB.Charts.renderers.map = function (widget, chart, data) {
        if (!data || data.length == 0) {
            widget.find('.loading-box').hide();
            return;
        }
        var gc = MDB.Charts.getGeocoder();
        gc.done(function (geocoder) {

            var keys = Object.keys(data[0]);
            var rows = [];
            var waits = [];
            var latAvg = 0;
            var lngAvg = 0;
            data.forEach(function (value, index) {
                var row = {
                    //shape: "pinTarget",
                    //shape: "pin",
                    location: null,
                    tooltip: {
                        content: value[keys[0]]
                    }
                };
                //for (var i = 1; i < 2 && i < keys.length; i++)
                //    row[i] = value[keys[i]];
                rows.push(row);

                if (value.Latitude && value.Longitude) {
                    row.location = [value.Latitude, value.Longitude];
                    latAvg += value.Latitude;
                    lngAvg += value.Longitude;
                } else {
                    waits[waits.length] = MDB.Charts.getCoordinatesForAddress(value[keys[0]], function (ll) {
                        if (ll) {
                            row.location = [ll.lat(), ll.lng()];
                        }
                    });
                }
            });

            // wait for the geocode requests to finish
            var continueFn = function continueFn_inner() {
                if (waits.length > 0) {
                    waits.shift().done(continueFn_inner).fail(continueFn_inner);
                    return;
                }

                widget.find('.loading-box').hide();
                chart.empty();

                //draw map
                chart.css({ 'min-height': '300px', overflow: 'hidden' }).height(
                    widget.find('.box-primary').height() -
                    widget.find('.box-header').outerHeight() -
                    widget.find('.ui-icon-gripsmall-diagonal-se').height());
                if (rows.length > 0) {
                    latAvg = latAvg / rows.length;
                    lngAvg = lngAvg / rows.length;
                }
                var cfg = {
                    center: latAvg != 0 ? [latAvg, lngAvg] : [53.2167, 6.5667],
                    zoom: 8,
                    controls: {
                        attribution: false,
                        navigator: false
                    },
                    markerDefaults: {
                        shape: "pinTarget"
                    },
                    layers: [{
                        type: "tile",
                        urlTemplate: "//#= subdomain #.tile.openstreetmap.org/#= zoom #/#= x #/#= y #.png",
                        subdomains: ["a", "b", "c"],
                        attribution: "&copy; <a href='http://osm.org/copyright'>OpenStreetMap contributors</a>"
                    }
                    ],
                    markers: rows
                };

                chart.kendoMap(cfg);
            };
            
            
            continueFn();
        });
    };

    MDB.Charts.renderers.google_maps = function (widget, chart, data, metadata) {
        MDB.Charts.renderers.map_generic(widget,  chart,  data,  metadata, function (containerId, renderConfig) {
            var loadGeoJson = function loadGeoJson(map, zoom) {
                if (map.prevZoom === zoom){
                    return;
                }

                map.prevZoom = zoom;

                var previousFeatureSet = [];

                map.data.forEach(function (previousFeature) {
                    previousFeatureSet.push(previousFeature);
                });

                map.data.loadGeoJson(renderConfig.getCombinedGeoJsonUrl(zoom), undefined, function (featureSet) {
                    previousFeatureSet.forEach(function (feature) {
                        map.data.remove(feature);
                    });
                });
            };


            var map = new google.maps.Map(document.getElementById(containerId), {
                zoom: renderConfig.baseZoom,
                center: {
                    lat: renderConfig.centerLat,
                    lng: renderConfig.centerLon
                }
            });

            renderConfig.loadGeoJson().forEach(function (prom) {
                prom.done(function (geoJson) {
                    map.data.addGeoJson(geoJson);
                })
            });
            
            // loadGeoJson(map, mapShapeZoomLevelGoogle);

			
            //To prevent hiccups when zooming multiple levels; appply a small delay before firing the function after the first load
            loadGeoJson = _.debounce(loadGeoJson, 750);
			
            renderConfig.markers.forEach(function (marker) {
                marker.map = map;
                new google.maps.Marker({
                    position: {
                        lat: marker.lat,
                        lng: marker.lon
                    },
                    title: marker.tooltip
                });
            });

            map.data.setStyle(function (feature) {
                var zipcode = feature.getProperty('zipcode');

                return {
                    fillColor: renderConfig.getZipcodeHeatmapColor(zipcode),
                    fillOpacity: renderConfig.getZipcodeHeatmapOpacity(zipcode),
                    strokeWeight: 0.5,
                    strokeColor: renderConfig.strokeColor
                };
            });

            // map.addListener('zoom_changed', function () {
            //     loadGeoJson(map, map.getZoom());
            // });

            map.data.addListener('mouseover', function (event) {
                var zipcode = event.feature.getProperty('zipcode');
                
                map.data.overrideStyle(event.feature, {
                    fillOpacity: renderConfig.hoverOpacity
                });

                if (renderConfig.getValueForZipcode(zipcode)){
                    renderConfig.displayPopover(zipcode)
                } 
            });

            map.data.addListener('mouseout', function (event) {
                renderConfig.hidePopover();

                map.data.revertStyle();
            });
        });
    };
})(jQuery, window, window.google);